import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CourseCard from "../components/CourseCard";

export default function CategoryPage() {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      api.get("/categories").then((r) => r.data).catch(() => []),
      api.get("/courses", { params: { category: slug, include_coming_soon: true } }).then((r) => r.data).catch(() => []),
    ]).then(([cats, cs]) => {
      setCategory(cats.find((c) => c.slug === slug) || null);
      setCourses(cs);
    }).finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="bg-fc-navy min-h-screen text-white">
      <Navbar />
      <main className="pt-32 pb-24" data-testid="category-page">
        <section className="max-w-7xl mx-auto px-6 lg:px-10">
          <Link
            to="/courses"
            className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm font-bold tracking-wider mb-8"
            data-testid="back-to-courses"
          >
            <ArrowLeft size={14} /> BACK TO ALL COURSES
          </Link>

          {category ? (
            <>
              <div className="mb-14 max-w-3xl">
                <div className="fc-overline mb-3">CATEGORY</div>
                <h1 className="fc-h-section text-4xl sm:text-5xl lg:text-6xl mb-5" data-testid="category-name">
                  <span className="text-fc-red">{category.name}.</span>
                </h1>
                <p className="text-white/70 text-lg leading-relaxed">
                  {category.description}
                </p>
              </div>

              {loading ? (
                <p className="text-white/50">Loading…</p>
              ) : courses.length === 0 ? (
                <p className="text-white/50">No courses available in this category yet.</p>
              ) : (
                <div
                  className="grid gap-6"
                  style={{ gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))" }}
                >
                  {[...courses].sort((a, b) => Number(!!a.is_coming_soon) - Number(!!b.is_coming_soon)).map((c) => (
                    <CourseCard key={c.id} course={c} />
                  ))}
                </div>
              )}
            </>
          ) : (
            <p className="text-white/60">Category not found.</p>
          )}
        </section>
      </main>
      <Footer />
    </div>
  );
}
